import React, { useState } from "react";
import * as MovementService from "../../../../services/MovementServices";
import PaginateList from "../../../utils/PaginateList";
import {
  MOVEMENT_STATUS,
  MOVEMENT_STATUS_ERROR,
} from "../../../../constants/index";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";
import { getDateFormatTimeZone } from "../../../../utils/formats";
import { Tooltip as ReactTooltip } from "react-tooltip";

const MovementListContainer = ({ filters, sortBy }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);

  const columns = [
    {
      header: t("forms.stockMovement.table.head.date"),
      accessorKey: "stockMovementDate",
      cell: (info) =>
        getDateFormatTimeZone(info.getValue(), "DD-MM-yyyy HH:mm"),
      size: 200,
    },
    {
      header: t("forms.stockMovement.table.head.batch"),
      accessorKey: "batch",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.stockMovement.table.head.fromLocationStorageCode"),
      accessorKey: "fromLocationStorageCode",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.stockMovement.table.head.toLocationStorageCode"),
      accessorKey: "toLocationStorageCode",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.stockMovement.table.head.status"),
      accessorKey: "status",
      cell: (info) => {
        const type = MOVEMENT_STATUS.find((st) => st.code === info.getValue());
        // console.log(info.getValue());
        if (info.getValue() === MOVEMENT_STATUS_ERROR.code) {
          const errorMsg = info.row?.original?.errorMessage
            ? info.row?.original?.errorMessage
            : t(type.label);
          return (
            <>
              <span
                data-tooltip-id={info.row?.original?.uuid}
                data-tooltip-content={errorMsg}
                data-tooltip-delay-hide={1000}
                style={{ cursor: "pointer", color: "#dc3545" }}
              >
                {t(type.label)}{" "}
                <i className="fa-solid fa-circle-exclamation"></i>
              </span>
              <ReactTooltip
                events={["click"]}
                effect="solid"
                id={info.row?.original?.uuid}
                style={{ maxWidth: "400px" }}
              />
            </>
          );
        }
        return type ? t(type.label) : info.getValue();
      },
    },
    // {
    //   header: t("forms.order.table.head.actions"),
    //   accessorKey: "uuid",
    //   cell: (info) => renderAction(info.row.uuid),
    // },
  ];

  // const renderAction = (data) => {
  //   return (data)}

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      filter.sort = "-date";
    }
    const result = await MovementService.listFilter(filter);

    return result;
  };

  const hide = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    hide.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    hide.itemCode = false;
  }
  return (
    <>
      <PaginateList
        refresh={forceRefresh}
        filters={filters}
        columns={columns}
        toList={listData}
        hideColum={hide}
        resize={resize}
        resetRefresh={() => setForceRefresh(false)}
      ></PaginateList>
    </>
  );
};

export default MovementListContainer;
